(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["Embroidary-from-data-append"] && !Shopify.designMode) return;
  try {
    window.getSaudiIconEmbroideryItems = function(parentVariantId, cartData) {
    const component = document.querySelector('saudi-icon-embroidery[data-selected="true"]');
    if (!component) return false;

    const freeServiceVariantId = component.dataset.serviceVariantId;
    const paidServiceVariantId = component.dataset.paidServiceVariantId;
    const selections = component.getSaudiSelections?.() || [];
    if (!freeServiceVariantId || !paidServiceVariantId || !selections.length) return false;

    const parentVariantInput = document.querySelector(
      'product-info product-form input.product-variant-id, product-info input.product-variant-id, product-form input.product-variant-id, input.product-variant-id'
    );
    const resolvedParentVariantId = parentVariantId || parentVariantInput?.value || '';
    let parentVariantSku = '';
    try {
      const parentVariantSkus = JSON.parse(
        component.querySelector('[data-parent-variant-skus]')?.textContent || '{}'
      );
      parentVariantSku = parentVariantSkus[String(resolvedParentVariantId)] || '';
    } catch (error) {
      console.error('Could not read the embroidered product SKU.', error);
    }
    const serviceVariantIds = [freeServiceVariantId, paidServiceVariantId].map(String);
    const existingSaudiServiceCount = cartData.items?.reduce((count, item) =>
      serviceVariantIds.includes(String(item.variant_id))
      && (
        item.properties?.['Embroidery Type'] === 'Saudi Icon'
        || item.properties?.['Saudi Icon Embroidery'] === 'Selected / تم الاختيار'
      )
        ? count + Number(item.quantity || 1)
        : count
    , 0) || 0;
    return selections.map((selection, index) => {
      const properties = {
        'Embroidery Type': 'Saudi Icon',
        'Saudi Icon Embroidery': 'Selected / تم الاختيار',
        'Saudi Icon Placement': selection.placement,
        'Saudi Icon Side': selection.side,
        'Saudi Icon Color': selection.color,
        '_Parent Product ID': component.dataset.parentProductId || '',
        '_Parent Variant ID': String(resolvedParentVariantId)
      };

      if (parentVariantSku) properties['_Embroidered Product SKU'] = parentVariantSku;

      return {
        id: Number(paidServiceVariantId),
        quantity: 1,
        properties
      };
    });
  };

  window.getSaudiIconEmbroideryItem = function(parentVariantId, cartData) {
    return window.getSaudiIconEmbroideryItems(parentVariantId, cartData)?.[0] || false;
  };

  window.addSaudiIconEmbroideryService = async function(parentVariantId) {
    const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!cartResponse.ok) throw new Error('Could not verify the cart before adding Saudi icon embroidery.');
    const cartData = await cartResponse.json();
    const serviceItems = window.getSaudiIconEmbroideryItems(parentVariantId, cartData);
    if (!serviceItems?.length) return false;

    return fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: serviceItems
      })
    }).then((response) => {
      if (!response.ok) throw new Error('Saudi icon embroidery service could not be added.');
      return response.json();
    });
  };

  if (!customElements.get('saudi-icon-embroidery')) {
    customElements.define('saudi-icon-embroidery', class SaudiIconEmbroidery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        setTimeout(() => this.initialize(), 0);
      }

      initialize() {
        this.toggle = this.querySelector('[data-saudi-toggle]');
        this.dialog = this.querySelector('[data-saudi-dialog]');
        this.options = this.querySelector('[data-saudi-options]');
        this.serviceInput = this.querySelector('[data-saudi-service]');
        this.inputs = Array.from(this.querySelectorAll('[data-saudi-input]'));
        this.sideStep = this.querySelector('[data-saudi-side-step]');
        this.sideInputs = this.inputs.filter((input) => input.name === 'properties[Saudi Icon Side]');
        this.colorInputs = this.inputs.filter((input) => input.hasAttribute('data-saudi-color'));
        this.colorStep = this.querySelector('[data-saudi-color-step]');
        this.productScope = this.closest('product-info') || document;
        this.onProductColorChange = (event) => {
          if (event.target.matches('.option-color input, .color-wrapper input, variant-selects input, variant-selects select, select[name*="Color"], select[name*="color"], select[name*="لون"]')) {
            setTimeout(() => this.updateState(), 0);
          }
        };
        this.productScope.addEventListener('change', this.onProductColorChange);
        this.removeButton = this.querySelector('[data-saudi-remove]');
        this.closeButton = this.querySelector('[data-saudi-close]');
        this.confirmButton = this.querySelector('[data-saudi-confirm]');
        this.addAnotherButton = this.querySelector('[data-saudi-add-another]');
        this.savedSummary = this.querySelector('[data-saudi-saved]');
        this.savedSummaryText = this.querySelector('[data-saudi-saved-text]');
        this.editFirstButton = this.querySelector('[data-saudi-edit-first]');
        this.savedSelections = [];

        this.toggle?.addEventListener('click', () => this.open());
        this.removeButton?.addEventListener('click', () => this.setEnabled(false));
        this.closeButton?.addEventListener('click', () => this.close());
        this.confirmButton?.addEventListener('click', () => this.close());
        this.addAnotherButton?.addEventListener('click', () => this.startAdditionalSelection());
        this.editFirstButton?.addEventListener('click', () => this.restoreFirstSelection());
        this.inputs.forEach((input) => input.addEventListener('change', () => this.updateState()));
        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }

      open() {
        this.setEnabled(true, false);
        this.dialog.showModal();
        this.toggle.setAttribute('aria-expanded', 'true');
        this.options.querySelector('input:not([type="hidden"])')?.focus();
      }

      disconnectedCallback() {
        this.productScope?.removeEventListener('change', this.onProductColorChange);
      }

      normalizeProductColor(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[أإآ]/g, 'ا')
          .replace(/ى/g, 'ي')
          .replace(/ة/g, 'ه')
          .replace(/[^a-z0-9\u0600-\u06FF]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      unavailableThreadColors() {
        const input = this.productScope.querySelector('.option-color input:checked, .color-wrapper input:checked');
        const label = input?.labels?.[0];
        const option = this.productScope.querySelector('select[name*="Color"], select[name*="color"], select[name*="لون"]')?.selectedOptions?.[0];
        const value = input?.getAttribute('data-color-input') || input?.getAttribute('data-filter2') || label?.getAttribute('data-color2') || label?.getAttribute('data-alt') || input?.getAttribute('data-alt') || option?.getAttribute('data-color2') || option?.value || input?.value || '';
        const normalizedColor = this.normalizeProductColor(value);
        return {
          Black: /(^| )(black|اسود)( |$)/.test(normalizedColor)
            || /navy|نيفي|كحلي/.test(normalizedColor)
            || /steel|pewter|رصاصي|رمادي فولاذي/.test(normalizedColor),
          White: /(^| )(white|ابيض)( |$)/.test(normalizedColor),
          Green: /(^| )(green|اخضر)( |$)/.test(normalizedColor)
            || /olive|زيتوني/.test(normalizedColor)
            || /hunter green|dark green|اخضر غامق|اخضر داكن/.test(normalizedColor),
          Gray: /(^| )(gray|grey|رمادي)( |$)/.test(normalizedColor),
          Navy: /navy|نيفي|كحلي/.test(normalizedColor)
        };
      }

      close() {
        if (!this.isComplete()) this.setEnabled(false, false);
        if (this.dialog.open) this.dialog.close();
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.focus();
      }

      isComplete() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked');
        const side = this.querySelector('input[name="properties[Saudi Icon Side]"]:checked');
        const color = this.querySelector('[data-saudi-color]:checked:not(:disabled)');
        return Boolean(placement && side && color);
      }

      currentSelection() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked')?.value;
        const side = this.querySelector('input[name="properties[Saudi Icon Side]"]:checked')?.value;
        const color = this.querySelector('[data-saudi-color]:checked:not(:disabled)')?.value;
        return placement && side && color ? { placement, side, color } : null;
      }

      getSaudiSelections() {
        const current = this.currentSelection();
        return current ? [...this.savedSelections, current] : [];
      }

      applySelection(selection) {
        if (!selection) return;
        const values = [selection.placement, selection.side, selection.color];
        this.inputs.forEach((input) => {
          input.checked = values.includes(input.value);
        });
        this.previousPlacement = selection.placement;
        this.updateState();
      }

      clearCurrentSelection() {
        this.inputs.forEach((input) => { input.checked = false; });
        this.previousPlacement = '';
        this.updateState();
      }

      updateSavedSummary() {
        const first = this.savedSelections[0];
        this.savedSummary.hidden = !first;
        if (first) this.savedSummaryText.textContent = `${first.placement} • ${first.side} • ${first.color}`;
      }

      startAdditionalSelection() {
        const first = this.currentSelection();
        if (!first || this.savedSelections.length) return;
        this.savedSelections = [first];
        this.updateSavedSummary();
        this.clearCurrentSelection();
        this.options.querySelector('input[name="properties[Saudi Icon Placement]"]')?.focus();
      }

      restoreFirstSelection() {
        const first = this.savedSelections[0];
        this.savedSelections = [];
        this.updateSavedSummary();
        this.applySelection(first);
      }

      updateState() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked');
        const placementValue = placement?.value || '';
        const showSide = Boolean(placement) && !this.serviceInput.disabled;
        this.sideStep.hidden = !showSide;
        this.colorStep.hidden = !showSide;
        const unavailableColors = this.unavailableThreadColors();
        const invalidSelection = this.colorInputs.some((input) => input.checked && unavailableColors[input.value]);
        if (invalidSelection && !this.dialog.open) {
          this.setEnabled(false, false);
          return;
        }
        for (const input of this.colorInputs) {
          const unavailable = Boolean(unavailableColors[input.value]);
          input.closest('[data-saudi-color-choice]').hidden = unavailable;
          input.disabled = !showSide || unavailable;
          if (input.disabled) input.checked = false;
        }
        for (const input of this.sideInputs) {
          input.disabled = !showSide;
          if (placementValue !== this.previousPlacement || !showSide) input.checked = false;
        }
        this.previousPlacement = placementValue;
        const sourceKey = placement?.value.startsWith('Bottom') ? 'bottomSrc' : 'sleeveSrc';
        for (const image of this.querySelectorAll('[data-saudi-side-preview]')) {
          const focusPlacement = sourceKey === 'bottomSrc' ? 'bottom' : 'sleeve';
          image.dataset.saudiFocus = `${focusPlacement}-${image.dataset.saudiSidePreview}`;
          const source = image.dataset[sourceKey];
          if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
        }
        const complete = this.isComplete();
        if (this.confirmButton) this.confirmButton.disabled = !complete;
        if (this.addAnotherButton) this.addAnotherButton.hidden = !complete || this.savedSelections.length > 0;
        this.dataset.selected = String(complete);
      }

      setEnabled(enabled, closeDialog = true) {
        this.serviceInput.disabled = !enabled;
        this.serviceInput.value = enabled ? 'Selected / تم الاختيار' : '';

        this.inputs.forEach((input) => {
          input.disabled = !enabled;
          if (!enabled) input.checked = false;
        });

        if (!enabled) {
          this.savedSelections = [];
          this.updateSavedSummary();
        }

        this.updateState();
        if (!enabled && closeDialog) this.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saudi-icon-embroidery"] && !Shopify.designMode) return;
  try {
    window.getSaudiIconEmbroideryItems = function(parentVariantId, cartData) {
    const component = document.querySelector('saudi-icon-embroidery[data-selected="true"]');
    if (!component) return false;

    const serviceVariantId = component.dataset.serviceVariantId;
    const selections = component.getSaudiSelections?.() || [];
    if (!serviceVariantId || !selections.length) return false;

    const parentVariantInput = document.querySelector(
      'product-info product-form input.product-variant-id, product-info input.product-variant-id, product-form input.product-variant-id, input.product-variant-id'
    );
    const resolvedParentVariantId = parentVariantId || parentVariantInput?.value || '';
    let parentVariantSku = '';
    try {
      const parentVariantSkus = JSON.parse(
        component.querySelector('[data-parent-variant-skus]')?.textContent || '{}'
      );
      parentVariantSku = parentVariantSkus[String(resolvedParentVariantId)] || '';
    } catch (error) {
      console.error('Could not read the embroidered product SKU.', error);
    }
    const serviceVariantIds = [String(serviceVariantId)];
    const existingSaudiServiceCount = cartData.items?.reduce((count, item) =>
      serviceVariantIds.includes(String(item.variant_id))
      && (
        item.properties?.['Embroidery Type'] === 'Saudi Icon'
        || item.properties?.['Saudi Icon Embroidery'] === 'Selected / تم الاختيار'
      )
        ? count + Number(item.quantity || 1)
        : count
    , 0) || 0;
    return selections.map((selection, index) => {
      const properties = {
        'Embroidery Type': 'Saudi Icon',
        'Saudi Icon Embroidery': 'Selected / تم الاختيار',
        'Saudi Icon Placement': selection.placement,
        'Saudi Icon Side': selection.side,
        'Saudi Icon Color': selection.color,
        '_Parent Product ID': component.dataset.parentProductId || '',
        '_Parent Variant ID': String(resolvedParentVariantId)
      };

      if (parentVariantSku) properties['_Embroidered Product SKU'] = parentVariantSku;

      return {
        id: Number(serviceVariantId),
        quantity: 1,
        properties
      };
    });
  };

  window.getSaudiIconEmbroideryItem = function(parentVariantId, cartData) {
    return window.getSaudiIconEmbroideryItems(parentVariantId, cartData)?.[0] || false;
  };

  window.addSaudiIconEmbroideryService = async function(parentVariantId) {
    const cartResponse = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!cartResponse.ok) throw new Error('Could not verify the cart before adding Saudi icon embroidery.');
    const cartData = await cartResponse.json();
    const serviceItems = window.getSaudiIconEmbroideryItems(parentVariantId, cartData);
    if (!serviceItems?.length) return false;

    return fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: serviceItems
      })
    }).then((response) => {
      if (!response.ok) throw new Error('Saudi icon embroidery service could not be added.');
      return response.json();
    });
  };

  if (!customElements.get('saudi-icon-embroidery')) {
    customElements.define('saudi-icon-embroidery', class SaudiIconEmbroidery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        setTimeout(() => this.initialize(), 0);
      }

      initialize() {
        this.toggle = this.querySelector('[data-saudi-toggle]');
        this.dialog = this.querySelector('[data-saudi-dialog]');
        this.options = this.querySelector('[data-saudi-options]');
        this.serviceInput = this.querySelector('[data-saudi-service]');
        this.inputs = Array.from(this.querySelectorAll('[data-saudi-input]'));
        this.sideStep = this.querySelector('[data-saudi-side-step]');
        this.sideInputs = this.inputs.filter((input) => input.name === 'properties[Saudi Icon Side]');
        this.colorInputs = this.inputs.filter((input) => input.hasAttribute('data-saudi-color'));
        this.colorStep = this.querySelector('[data-saudi-color-step]');
        this.productScope = this.closest('product-info') || document;
        this.onProductColorChange = (event) => {
          if (event.target.matches('.option-color input, .color-wrapper input, variant-selects input, variant-selects select, select[name*="Color"], select[name*="color"], select[name*="لون"]')) {
            setTimeout(() => this.updateState(), 0);
          }
        };
        this.productScope.addEventListener('change', this.onProductColorChange);
        this.removeButton = this.querySelector('[data-saudi-remove]');
        this.closeButton = this.querySelector('[data-saudi-close]');
        this.confirmButton = this.querySelector('[data-saudi-confirm]');
        this.addAnotherButton = this.querySelector('[data-saudi-add-another]');
        this.savedSummary = this.querySelector('[data-saudi-saved]');
        this.savedSummaryText = this.querySelector('[data-saudi-saved-text]');
        this.editFirstButton = this.querySelector('[data-saudi-edit-first]');
        this.savedSelections = [];

        this.toggle?.addEventListener('click', () => this.open());
        this.removeButton?.addEventListener('click', () => this.setEnabled(false));
        this.closeButton?.addEventListener('click', () => this.close());
        this.confirmButton?.addEventListener('click', () => this.close());
        this.addAnotherButton?.addEventListener('click', () => this.startAdditionalSelection());
        this.editFirstButton?.addEventListener('click', () => this.restoreFirstSelection());
        this.inputs.forEach((input) => input.addEventListener('change', () => this.updateState()));
        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }

      open() {
        this.setEnabled(true, false);
        this.dialog.showModal();
        this.toggle.setAttribute('aria-expanded', 'true');
        this.options.querySelector('input:not([type="hidden"])')?.focus();
      }

      disconnectedCallback() {
        this.productScope?.removeEventListener('change', this.onProductColorChange);
      }

      normalizeProductColor(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[أإآ]/g, 'ا')
          .replace(/ى/g, 'ي')
          .replace(/ة/g, 'ه')
          .replace(/[^a-z0-9\u0600-\u06FF]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      unavailableThreadColors() {
        const input = this.productScope.querySelector('.option-color input:checked, .color-wrapper input:checked');
        const label = input?.labels?.[0];
        const option = this.productScope.querySelector('select[name*="Color"], select[name*="color"], select[name*="لون"]')?.selectedOptions?.[0];
        const value = input?.getAttribute('data-color-input') || input?.getAttribute('data-filter2') || label?.getAttribute('data-color2') || label?.getAttribute('data-alt') || input?.getAttribute('data-alt') || option?.getAttribute('data-color2') || option?.value || input?.value || '';
        const normalizedColor = this.normalizeProductColor(value);
        return {
          Black: /(^| )(black|اسود)( |$)/.test(normalizedColor)
            || /navy|نيفي|كحلي/.test(normalizedColor)
            || /steel|pewter|رصاصي|رمادي فولاذي/.test(normalizedColor),
          White: /(^| )(white|ابيض)( |$)/.test(normalizedColor),
          Green: /(^| )(green|اخضر)( |$)/.test(normalizedColor)
            || /olive|زيتوني/.test(normalizedColor)
            || /hunter green|dark green|اخضر غامق|اخضر داكن/.test(normalizedColor),
          Gray: /(^| )(gray|grey|رمادي)( |$)/.test(normalizedColor),
          Navy: /navy|نيفي|كحلي/.test(normalizedColor)
        };
      }

      close() {
        if (!this.isComplete()) this.setEnabled(false, false);
        if (this.dialog.open) this.dialog.close();
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.focus();
      }

      isComplete() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked');
        const side = this.querySelector('input[name="properties[Saudi Icon Side]"]:checked');
        const color = this.querySelector('[data-saudi-color]:checked:not(:disabled)');
        return Boolean(placement && side && color);
      }

      currentSelection() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked')?.value;
        const side = this.querySelector('input[name="properties[Saudi Icon Side]"]:checked')?.value;
        const color = this.querySelector('[data-saudi-color]:checked:not(:disabled)')?.value;
        return placement && side && color ? { placement, side, color } : null;
      }

      getSaudiSelections() {
        const current = this.currentSelection();
        return current ? [...this.savedSelections, current] : [];
      }

      applySelection(selection) {
        if (!selection) return;
        const values = [selection.placement, selection.side, selection.color];
        this.inputs.forEach((input) => {
          input.checked = values.includes(input.value);
        });
        this.previousPlacement = selection.placement;
        this.updateState();
      }

      clearCurrentSelection() {
        this.inputs.forEach((input) => { input.checked = false; });
        this.previousPlacement = '';
        this.updateState();
      }

      updateSavedSummary() {
        const first = this.savedSelections[0];
        this.savedSummary.hidden = !first;
        if (first) this.savedSummaryText.textContent = `${first.placement} • ${first.side} • ${first.color}`;
      }

      startAdditionalSelection() {
        const first = this.currentSelection();
        if (!first || this.savedSelections.length) return;
        this.savedSelections = [first];
        this.updateSavedSummary();
        this.clearCurrentSelection();
        this.options.querySelector('input[name="properties[Saudi Icon Placement]"]')?.focus();
      }

      restoreFirstSelection() {
        const first = this.savedSelections[0];
        this.savedSelections = [];
        this.updateSavedSummary();
        this.applySelection(first);
      }

      updateState() {
        const placement = this.querySelector('input[name="properties[Saudi Icon Placement]"]:checked');
        const placementValue = placement?.value || '';
        const showSide = Boolean(placement) && !this.serviceInput.disabled;
        this.sideStep.hidden = !showSide;
        this.colorStep.hidden = !showSide;
        const unavailableColors = this.unavailableThreadColors();
        const invalidSelection = this.colorInputs.some((input) => input.checked && unavailableColors[input.value]);
        if (invalidSelection && !this.dialog.open) {
          this.setEnabled(false, false);
          return;
        }
        for (const input of this.colorInputs) {
          const unavailable = Boolean(unavailableColors[input.value]);
          input.closest('[data-saudi-color-choice]').hidden = unavailable;
          input.disabled = !showSide || unavailable;
          if (input.disabled) input.checked = false;
        }
        for (const input of this.sideInputs) {
          input.disabled = !showSide;
          if (placementValue !== this.previousPlacement || !showSide) input.checked = false;
        }
        this.previousPlacement = placementValue;
        const sourceKey = placement?.value.startsWith('Bottom') ? 'bottomSrc' : 'sleeveSrc';
        for (const image of this.querySelectorAll('[data-saudi-side-preview]')) {
          const focusPlacement = sourceKey === 'bottomSrc' ? 'bottom' : 'sleeve';
          image.dataset.saudiFocus = `${focusPlacement}-${image.dataset.saudiSidePreview}`;
          const source = image.dataset[sourceKey];
          if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
        }
        const complete = this.isComplete();
        if (this.confirmButton) this.confirmButton.disabled = !complete;
        if (this.addAnotherButton) this.addAnotherButton.hidden = !complete || this.savedSelections.length > 0;
        this.dataset.selected = String(complete);
      }

      setEnabled(enabled, closeDialog = true) {
        this.serviceInput.disabled = !enabled;
        this.serviceInput.value = enabled ? 'Selected / تم الاختيار' : '';

        this.inputs.forEach((input) => {
          input.disabled = !enabled;
          if (!enabled) input.checked = false;
        });

        if (!enabled) {
          this.savedSelections = [];
          this.updateSavedSummary();
        }

        this.updateState();
        if (!enabled && closeDialog) this.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
